import React from "react";
import { FormattedMessage } from "react-intl";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";

export const AccountsLabel = ({
  children = <FormattedMessage id="accounts" />,
  ...rest
}: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="list-alt" {...rest}>
      {children}
    </RaangeLabel>
  );
};
export const AccountCreate = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="accounts.create" />
    </RaangeLabel>
  );
};
export const AccountEdit = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="pencil-alt" {...props}>
      <FormattedMessage id="accounts.edit" />
    </RaangeLabel>
  );
};
